// 2026-06-19 - FormuLearning - plotly 차트 테마 토큰 (이슈 #9)
// 파일 위치: frontend/src/lib/chartTheme.ts
// 현재 <html data-theme>에 적용된 CSS 변수 값을 읽어 차트 색상을 테마에 맞춘다.
// 차트 컴포넌트는 useEffect 의존성에 theme를 넣어 토글 시 재렌더한다.

export interface ChartTokens {
  font: string
  grid: string
  plotBg: string
  purple: string
  teal: string
  amber: string
  red: string
}

export function chartTokens(): ChartTokens {
  const cs = getComputedStyle(document.documentElement)
  const v = (name: string, fallback: string) => cs.getPropertyValue(name).trim() || fallback
  return {
    font: v('--color-text-body', '#e8eaed'),
    grid: v('--chart-grid', 'rgba(255,255,255,0.04)'),
    plotBg: v('--chart-plot-bg', 'rgba(255,255,255,0.02)'),
    purple: v('--color-accent-purple', '#9b8afb'),
    teal: v('--color-accent-teal', '#4fd1c5'),
    amber: v('--color-warn', '#ffb84d'),
    red: v('--color-danger', '#ff7a7a'),
  }
}
